// extracted by mini-css-extract-plugin
var _1 = "iM6bn7aL";
export { _1 as "sidebar" }
